import { List } from 'immutable'
import * as actions from './actions'
import Result from './Result'
import Mistake from './Mistake'
import CurrentImageNote from './CurrentImageNote'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  meta: new ListMeta(),
  all: new List(),
  current: new Result(),
  endOfDriveTime: null,
  currentMistakes: new List(),
  currentImageNotes: new List(),
  currentMistakeType: '',
  resultSummaryNotes: {},
}, 'results')

const resultsReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.RESULTS_LOAD_START: {
      const results = List(action.payload.data.map(json => Result.fromJS(json)))
      return state.set('all', results).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.RESULTS_LOAD_SUCCESS: {
      const results = List(action.payload.data.map(json => Result.fromJS(json)))
      return state.set('all', results).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.RESULT_LOAD_SUCCESS: {
      const result = Result.fromJS(action.payload.data)
      return state.set('current', result)
    }
    case actions.RESULT_CREATE_SUCCESS: {
      const result = Result.fromJS(action.payload.data)
      return state.set('current', result)
    }
    case actions.RESULT_UPDATE_SUCCESS: {
      const result = Result.fromJS(action.payload.data)
      return state.set('current', result)
    }
    case actions.RESULT_UPDATE_CURRENT_LOCALLY: {
      const result = state.current.toJS()
      const update = action.payload.body
      const newResult = new Result(Object.assign(result, update))
      return state.set('current', newResult)
    }
    case actions.RESULT_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case actions.CLEAR_RESULTS: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.CLEAR_RESULT: {
      return state.set('current', new Result())
    }
    case actions.RESULT_SET_DRIVE_END_TIME: {
      return state.set('endOfDriveTime', action.payload.minutes)
    }
    case actions.RESULT_CLEAR_DRIVE_END_TIME: {
      return state.set('endOfDriveTime', 0)
    }
    case actions.MISTAKE_ADD: {
      const mistake = new Mistake(action.payload.mistake)
      return state.set('currentMistakes', state.currentMistakes.push(mistake))
    }
    case actions.MISTAKE_COUNT_INCREMENT: {
      const index = action.payload.index
      const previousMistake = state.currentMistakes.get(index)
      const newCount = previousMistake.count + 1
      const newMistake = new Mistake(Object.assign(
        previousMistake.toJS(),
        { count: newCount },
      ))
      return state.set('currentMistakes', state.currentMistakes.set(index, newMistake))
    }
    case actions.MISTAKE_COUNT_DECREMENT: {
      const index = action.payload.index
      const previousMistake = state.currentMistakes.get(index)
      const newCount = (previousMistake.count > 1)
        ? previousMistake.count - 1
        : previousMistake.count
      const newMistake = new Mistake(Object.assign(
        previousMistake.toJS(),
        { count: newCount },
      ))
      return state.set('currentMistakes', state.currentMistakes.set(index, newMistake))
    }
    case actions.DELETE_MISTAKE: {
      const index = action.payload.index
      return state.set('currentMistakes', state.currentMistakes.delete(index))
    }
    case actions.CLEAR_MISTAKES: {
      return state.set('currentMistakes', new List())
    }
    case actions.RESULT_ADD_IMAGE_NOTE: {
      const imageNote = new CurrentImageNote(action.payload)
      return state.set('currentImageNotes', state.currentImageNotes.push(imageNote))
    }
    case actions.RESULT_EDIT_IMAGE_NOTE: {
      const { index, image } = action.payload
      const currentImageNote = state.currentImageNotes.get(index).toJS()
      const newCurrentImageNote = new CurrentImageNote(Object.assign(currentImageNote, { image }))
      return state.set('currentImageNotes', state.currentImageNotes.set(index, newCurrentImageNote))
    }
    case actions.RESULT_REMOVE_IMAGE_NOTE: {
      const { index } = action.payload
      return state.set('currentImageNotes', state.currentImageNotes.delete(index))
    }
    case actions.SET_CURRENT_MISTAKE_TYPE: {
      const { type } = action.payload
      return state.set('currentMistakeType', type)
    }
    case actions.CLEAR_CURRENT_MISTAKE_TYPE: {
      return state.set('currentMistakeType', '')
    }
    case actions.CLEAR_IMAGE_NOTES: {
      return state.set('currentImageNotes', new List())
    }
    case actions.CLEAR_END_OF_DRIVE_TIME: {
      return state.set('endOfDriveTime', null)
    }
    case actions.CLEAR_RESULT_SUMMARY_NOTES: {
      return state.set('resultSummaryNotes', {})
    }
    case actions.SET_RESULT_SUMMARY_NOTE: {
      const summary = state.get('resultSummaryNotes')
      summary[action.payload.field] = action.payload.image
      return state.set('resultSummaryNotes', Object.assign({}, summary))
    }
    case actions.SET_MISTAKE_PREFIX: {
      const { index, prefix } = action.payload
      const mistake = state.currentMistakes.get(index)
      const newMistake = new Mistake(
        Object.assign(
          mistake.toJS(),
          { count: 1, prefix },
        ))
      return state.set('currentMistakes', state.currentMistakes.set(index, newMistake))
    }
    default:
      return state
  }
}

export default resultsReducer



// WEBPACK FOOTER //
// ./src/common/results/reducer.js